import { createActionGroup, emptyProps } from '@ngrx/store';

const PREFIX = '[App]';

export const RootActions = createActionGroup({
  source: `${PREFIX} Root`,
  events: {
    clearState: emptyProps(),
  },
});
